import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { embeddingReducerPath } from './const';
import { EmbeddingState } from './types';

export * from './const';
export * from './selectors';
export * from './types';

const initialState: EmbeddingState = {
  sharedState: {},
};

export const embeddingSlice = createSlice({
  name: `@@app/${embeddingReducerPath}`,
  initialState,
  reducers: {
    updateSharedState(state, action: PayloadAction<Partial<EmbeddingState['sharedState']>>) {
      for (const prop in action.payload) {
        state.sharedState[prop] = action.payload[prop];
      }
    },
  },
});
